import { springClient } from "apis/config/apiClient";

// 새로운 API 응답 구조에 맞춘 인터페이스
export interface CompanyInfo {
  name: string;
  industry: {
    code: string;
    name: string;
    other?: string;
  };
  size: {
    code: string;
    name: string;
  };
  jobPosition?: {
    code: string;
    name: string;
    other?: string;
  };
  jobDuties?: {
    code: string;
    name: string;
    other?: string;
  };
}

export interface UserProfile {
  email: string;
  profile: {
    name: string;
  };
  company: CompanyInfo;
  membership: {
    level: string;
    key: string;
  };
  consent: {
    isPrivacy: boolean;
    isMarketing: boolean;
  };
  createdDate: string;
}

export interface ProfileApiResponse {
  status: number;
  message: string;
  data: UserProfile;
}

export interface ProfileUpdateData {
  username: string;
  organization: string;
  jobPosition: string;
  industry: {
    code: string;
    other?: string | null;
  };
  size: {
    code: string;
    other?: string | null;
  };
  jobPositionCode: string;
  jobDuties: {
    code: string;
    other?: string | null;
  };
  consent: {
    isPrivacy: boolean;
    isMarketing: boolean;
  };
}

export interface PasswordUpdateData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface PasswordUpdateRequest {
  password: string;
  identity: string;
}

export interface UpdateResponse {
  success: boolean;
  message?: string;
}

// 사용자 프로필 조회 (원본 API 응답)
export const getUserProfile = async (): Promise<UserProfile> => {
  try {
    const response = await springClient.get(`/me`);
    
    if (response.data?.data) {
      return response.data.data;
    }
    throw new Error("프로필 데이터를 찾을 수 없습니다.");
  } catch (error) {
    console.error("Failed to fetch user profile:", error);
    throw error;
  }
};

// 프로필 업데이트
export const updateUserProfile = async (profileData: ProfileUpdateData): Promise<UpdateResponse> => {
  try {
    const requestBody = {
      profile: {
        name: profileData.username,
      },
      company: {
        name: profileData.organization,
        industry: profileData.industry,
        size: profileData.size,
        jobPosition: {
          code: profileData.jobPositionCode,
          other: profileData.jobPositionCode === "other" ? profileData.jobPosition : null,
        },
        jobDuties: profileData.jobDuties,
      },
      consent: profileData.consent,
    };

    const response = await springClient.put(`/me`, requestBody);

    return {
      success: response.data.status === 200 || response.data.success,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Failed to update profile:", error);
    throw error;
  }
};

// 비밀번호 변경
export const updateUserPassword = async (passwordData: PasswordUpdateData): Promise<void> => {
  try {
    const requestData: PasswordUpdateRequest = {
      password: passwordData.newPassword,
      identity: passwordData.currentPassword,
    };
    
    await springClient.patch(`/me/password`, requestData);
  } catch (error) {
    console.error("Failed to update password:", error);
    throw error;
  }
};
